import { render, staticRenderFns } from "./GiftsHospitalityUser.vue?vue&type=template&id=55c1cf8d&"
import script from "./GiftsHospitalityUser.vue?vue&type=script&lang=js&"
export * from "./GiftsHospitalityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports